import { useEffect, useRef, useState } from 'react'
import { withConfirmation } from 'components/ideal-core-ui'
import { useBlocker } from 'hooks'

const useUnsavedChanges = (shouldPrompt, callback) => {
  const retryFn = useRef(() => {})
  const [confirmedNavigation, setConfirmedNavigation] = useState(false)

  useEffect(() => {
    if (confirmedNavigation) {
      retryFn.current()
    }
  }, [confirmedNavigation])

  const handleBlockNavigation = ({ retry }) => {
    const shouldDisplayPrompt = typeof shouldPrompt === 'boolean' ? shouldPrompt : shouldPrompt()

    if (shouldDisplayPrompt) {
      withConfirmation(
        () => {
          callback(() => {
            setConfirmedNavigation(true)
            retryFn.current = retry
          })
        },
        {
          title: 'You have unsaved changes',
          text: 'Would you like to save before you proceed?',
          buttons: {
            cancel: 'Stay on Page',
            discard: {
              text: 'Discard',
              value: 'secondaryConfirm'
            },
            confirm: {
              text: 'Save',
              value: true
            }
          }
        },
        () => {
          setConfirmedNavigation(true)
          retryFn.current = retry
        }
      )()
    } else {
      retry()
    }
  }

  useBlocker(handleBlockNavigation, !confirmedNavigation && shouldPrompt)
}

export default useUnsavedChanges
